import React, { useEffect, useState } from 'react';
import SeachInput from 'components/form/SeachInput';
import ExportButton from 'components/Layout/ExportButton';
import Table from 'components/Layout/Table';
import { useDispatch, useSelector } from 'react-redux';
import { limit } from 'utils/constants';
import { objectToFormData, titleCaseString } from 'utils/helpers';
import { useParams } from 'react-router-dom';
import './AttendancesList.scss';
import { fetchCoAuthorAttendancesList } from 'store/slices/adminSlice';
import usePermission from 'hooks/usePermission';

const getAttendanceStatusLabelStyle = (label) => {
    if (label === 0) {
        return 'color-C991';
    }
    if (label === 1) {
        return 'color-a35b';
    }
    if (label === 2) {
        return 'color-4646';
    }
};

const CoAuthorAttendancesList = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const { membershipList, } = useSelector((state) => ({
        membershipList: state.global.membershipList,
    }));
    const [globalSearchVal, setGlobalSearchVal] = useState('');
    const [timer, setTimer] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [tableList, setTableList] = useState([]);
    const [searchPayload, setSearchPayload] = useState({
        user_name: '',
        abstract_id: '',
        membership_id: '',
        membership_type: '',
        attendance: '',
    });
    const [filterData, setFilterData] = useState({
        total: 0,
        offset: 0,
        limit: limit,
        event_id: params?.eventId,
    });

    const path = window.location.pathname;
    const segments = path.split('/');
    const targetValue = segments[2] || '';
    const permissionMapping = {
        'event-management': 'Event Management',
        'chapters-groups': 'Chapters & Group Management',
    };
    const permissionName = permissionMapping[targetValue] || '';
    const { viewAccess } = usePermission(permissionName);

    const getCoAuthorAttendancesList = async (obj) => {
        const response = await dispatch(
            fetchCoAuthorAttendancesList(objectToFormData(obj))
        );
        setTableList(response?.data?.co_author_details || []);
        setFilterData({
            ...obj,
            total: response?.data?.result_count || 0,
        });
        setIsLoading(false);
    };

    const handelChangeSearch = (searchData) => {
        setIsLoading(true);
        let newData = filterData;
        setSearchPayload(searchData);
        newData = { ...newData, ...searchData, offset: 0 };
        setFilterData(newData);
        getCoAuthorAttendancesList(newData);
    };

    const handelChangePagination = (offset) => {
        setIsLoading(true);
        let newData = { ...filterData, ...searchPayload };
        newData = { ...newData, offset: offset };
        setFilterData(newData);
        getCoAuthorAttendancesList(newData);
    };

    const handleGlobalSearch = (e) => {
        setGlobalSearchVal(e.target.value);
        let time = timer;
        clearTimeout(time);
        time = setTimeout(() => {
            let newData = { ...filterData, ...searchPayload };
            newData = { ...newData, global_filter: e.target.value, offset: 0 };
            setIsLoading(true);
            setFilterData(newData);
            getCoAuthorAttendancesList(newData);
        }, 800);
        setTimer(time);
    };

    useEffect(() => {
        getCoAuthorAttendancesList({ ...filterData, ...searchPayload });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    const header = [
        {
            isSearch: false,
            searchInputName: '',
            title: 'S.No',
        },
        {
            isSearch: true,
            searchInputName: 'user_name',
            title: 'Name',
        },
        {
            isSearch: true,
            searchInputName: 'abstract_id',
            title: <span className="text-nowrap">Abstract Id</span>,
        },
        {
            isSearch: true,
            searchInputName: 'membership_id',
            title: <span className="text-nowrap">Membership Id</span>,
        },
        {
            isSearch: true,
            isSearchDropdown: true,
            searchInputName: 'membership_type',
            dropdownOptions: {
                options: membershipList,
                key: 'name',
                value: 'name',
            },
            title: <span className="text-nowrap">Membership Type</span>,
        },


        {
            isSearch: true,
            searchInputName: 'attendance',
            isSearchDropdown: true,
            dropdownOptions: {
                options: [
                    { id: 0, name: 'Pending' },
                    { id: 1, name: 'Present' },
                    { id: 2, name: 'Absent' },
                ],
                key: 'id',
                value: 'name',
            },
            title: <span className="text-nowrap">Attendance</span>,
        },

    ];
    const rowData = [];
    tableList?.forEach((elem, index) => {
        let obj = [
            {
                value: <span>{filterData?.offset + index + 1}</span>,
            },
            {
                value: <span className="text-nowrap">{elem?.user_name ? elem?.user_name : '-'}</span>,
            },
            {
                value: <span className="text-nowrap">{elem?.abstract_id ? elem?.abstract_id : '-'}</span>,
            },
            {
                value: <span className="text-nowrap">{elem?.membership_id ? elem?.membership_id : '-'}</span>,
            },
            {
                value: <span className="text-nowrap">{elem?.membership_type ? elem?.membership_type : '-'}</span>,
            },

            {
                value: (
                    <span
                        className={`${getAttendanceStatusLabelStyle(
                            elem?.attendance
                        )} text-wrap`}
                    >
                        {elem?.attendance === 0
                            ? 'Pending'
                            : elem?.attendance === 1
                                ? 'Present'
                                : 'Absent'}
                    </span>
                ),
            },

        ];
        rowData.push({ data: obj });
    });
    return (
        <>
            <div className="d-flex justify-content-between align-items-center cpt-10 cpb-10">
                <div className="table-title">Co-Author Attendances ({filterData?.total})</div>

                <div className="d-flex align-items-center flex-wrap gap-3">
                    <div className="d-flex">
                        <SeachInput
                            placeholder="Search here"
                            id="global_filter"
                            value={globalSearchVal}
                            onChange={handleGlobalSearch}
                        />
                    </div>
                    {viewAccess === '1' && (
                        <ExportButton
                            newHeight={'h-45'}
                            exportAPI={fetchCoAuthorAttendancesList}
                            payload={objectToFormData({
                                ...filterData,
                                ...searchPayload,
                                export_status: 1,
                            })}
                            payloadID={{ isExport: 1 }}
                        />
                    )}
                </div>
            </div>
            <Table
                isLoading={isLoading}
                header={header}
                rowData={rowData}
                filterData={filterData}
                searchPayload={searchPayload}
                searchInputChange={handelChangeSearch}
                changeOffset={handelChangePagination}
            />
        </>
    );
};

export default CoAuthorAttendancesList;

